let isResetRouteQuery = true;
import {
  getAreas,
  getSyncUrl,
  getTextbooks,
  updateLastUsedGradeAndTerm,
} from "@/utils/apis";
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {
      catalogType: "isCatalog",
      overOneLine: false,
      isOpen: false,
      teachLists: [],
      syncUrl: "",
      // 城市列表
      cityList: [],
      currentCity: "",
      isShowCityList: false,
      isDisableCheckAlbum: false,
    };
  },
  computed: {
    ...mapState(["currentGloablPageId", "isFolded"]),
  },
  watch: {
    $route: {
      handler(to, from) {
        // console.log("mixins执行的函数");
        // console.log("to,from", to, from);
        this.watchRouteChange(to, from);
        let {
          parentScenarioKpoints,
          pageId = 1,
          subjectFeatureType,
          parentScenarioId,
          parentCatalogIds,
          parentSubjectFeatures,
          parentAreaIds,
        } = to.query;
        if (pageId == 1 || pageId == 8) {
          this.catalogType =
            this.$route.query && parentScenarioId
              ? "isExamCatalog"
              : "isCatalog";
        } else if (pageId == 3) {
          this.catalogType = "isKnowlegdeCatalog";
        } else {
          if (parentScenarioKpoints) {
            this.catalogType = "isScenarioKpoints";
          } else if (subjectFeatureType) {
            this.catalogType = "isSubjectCharacteristic";
          } else if (parentSubjectFeatures) {
            this.catalogType = "isParentSubjectFeatures";
          } else {
            this.catalogType = "isExamCatalog";
          }
        }
        if (to) {
          this.currentTextbook && this.judgeShowToSyncPageBtn();
        }
        // this.isDisableCheckAlbum =
        //   (pageId == 5 && parentSubjectFeatures) ||
        //   (pageId == 2 && parentScenarioKpoints);
        this.isDisableCheckAlbum =
          parentSubjectFeatures ||
          (parentScenarioKpoints &&
            (pageId == 5 || pageId == 6 || pageId == 7));
        // 处理更多显示问题
      },
      deep: true,
      immediate: true,
    },
    isFolded: {
      handler(to, from) {
        this.handleResize();
      },
    },
    currentGloablPageId: {
      handler(val) {
        let {
          parentScenarioId,
          parentScenarioKpoints,
          subjectFeatureType,
          parentSubjectFeatures,
        } = this.$route.query;
        if (val == 1) {
          this.catalogType =
            this.$route.query && parentScenarioId
              ? "isExamCatalog"
              : "isCatalog";
        } else if (val == 3) {
          this.catalogType = "isKnowlegdeCatalog";
        } else {
          if (parentScenarioKpoints) {
            this.catalogType = "isScenarioKpoints";
          } else if (subjectFeatureType) {
            this.catalogType = "isSubjectCharacteristic";
          } else if (parentSubjectFeatures) {
            this.catalogType = "isParentSubjectFeatures";
          } else {
            this.catalogType = "isExamCatalog";
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations(["changeTextBookList"]),
    handleCatalogParams(node, params) {
      let typeCode = node.typeCode;
      switch (typeCode) {
        case 3:
          params.isCatalog = true;
          break;
        case 4:
          params.isKnowlegdeCatalog = true;
          break;
        case 5:
          params.isExamCatalog = true;
          break;
        case 6:
          params.isSubjectCharacteristic = true;
          break;
        case 7:
          params.isParentSubjectFeatures = true;
          break;
        case 8:
          params.isScenarioKpoints = true;
          break;
        case 10:
          params.isArea = true;
          break;
        case 11:
          params.isSchool = true;
          break;
        case 9:
          params.isSeries = true;
          break;
      }
      return params;
    },
    handleResize() {
      // console.log("-----handleResize");
      this.overOneLine = false;
      this.$nextTick(() => {
        if (this.$refs.areaFilter) {
          const width = this.$refs.areaFilter.offsetWidth;
          const height = this.$refs.areaFilter.offsetHeight;
          // console.log("----height", height, width);
          // 在这里处理宽高变化的逻辑
          this.overOneLine = height > 36;
        }
      });
    },
    // 获取当前资源类型
    async getCurrentCategory(category) {
      let { id } = category;
      if (!id) {
        this.currentCategory = "";
        this.currentSubType = "";
        this.currentSubCategory = "";
        this.resourceOptions = [];
        this.resourceRanges = [];
        this.resourceSubTypes = [];
        this.resourceSubCategories = [];
        // delete
      } else {
        if (id.length > 4) {
          this.currentSubCategory = id || "";
          this.currentCategory = id.slice(0, 4) || "";
        } else {
          this.currentSubCategory = "";
          this.currentCategory = id || "";
          this.resourceSubCategories = category.navFilterChildNode || [];
        }
        this.currentSubType = "";
        this.resourceSubTypes = [];
      }
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isOrder: true,
        isFileType: true,
        isArea: true,
        isYear: true,
        isGrade: true,
        isTerm: true,
        isClass: true,
        isRange: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      // 更新路由的query,
      this.updateQuery(query, isResetRouteQuery);
    },
    // 当前选中的年级
    getCurrentGrade(grade) {
      this.currentGrade = grade.id || "";
      let params = {
        [this.catalogType]: true,
        currentScene: true,
        isCategory: true,
        isOption: true,
        isScene: true,
        isClass: true,
        isYear: true,
        isGrade: true,
        isRange: true,
        isTerm: true,
        isArea: true,
        isOrder: true,
        isFileType: true,
        isSubType: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      // 更新路由的query
      this.updateQuery(query, isResetRouteQuery);
    },
    getCurrentYear(item) {
      this.currentYear = item.id || "";
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        isOption: true,
        isRange: true,
        isArea: true,
        isClass: true,
        isYear: true,
        isTerm: true,
        isGrade: true,
        isOrder: true,
        isFileType: true,
        isSubType: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    async getCurrentArea(item, isPaper = false, isSubPaper = false) {
      console.log("item, isPaper", item, isPaper);
      // if(!isPaper){
      this.currentArea = item.id || "";
      let params = {
        isCategory: true,
        isScene: true,
        isOption: true,
        isRange: true,
        isArea: true,
        isClass: true,
        isYear: true,
        isGrade: true,
        isTerm: true,
        isOrder: true,
        isFileType: true,
        isSubType: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isVersion: true,
        isSchool: true,
      };
      let path = this.$route.path;
      if (path.includes("juemi")) {
        params.isSeries = true;
      } else {
        params[this.catalogType] = true;
      }
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
      // }else{
      let isProv = item.id.slice(2) == "0000" || item.id.length == 1;
      let provinceId = isProv ? item.id : item.id.slice(0, 2) + "0000";
      !isProv ? (this.currentCity = item.id) : null;
      this.currentArea = item.id ? provinceId : "";
      if (isProv && !isPaper && !isSubPaper) {
        this.cityList = [];
        this.currentCity = null;
        this.isShowCityList = false;
      }
      // if(isSubPaper){
      this.isShowCityList = isSubPaper;
      // }
      isSubPaper ? (this.currentCity = item.id) : null;
      if (isPaper) {
        this.currentCity = item.id;
        await this.getCityList(item.id);
      }
      this.$nextTick(() => {
        this.handleResize();
      });
    },
    initCityList() {
      let { parentAreaIds } = this.$route.query;
      let isProv = parentAreaIds.slice(2) == "0000";
      let provinceId = isProv
        ? parentAreaIds
        : parentAreaIds.slice(0, 2) + "0000";
      // !isProv ? (this.currentCity = parentAreaIds) : null;
      this.currentCity = parentAreaIds;
      this.currentArea = provinceId;
      // if(isProv){
      this.getCityList(provinceId);
      // }
    },
    async getCityList(parentId) {
      let data = await getAreas({
        parentId,
      });
      this.isShowCityList = data.result && data.result.length > 1;
      this.cityList = data.result || [];
    },
    getCurrentClass(item) {
      this.currentClass = item.id || "";
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        isOption: true,
        isRange: true,
        isClass: true,
        isGrade: true,
        isTerm: true,
        isArea: true,
        isYear: true,
        isOrder: true,
        isFileType: true,
        isSubType: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    handleUpdateQuery(e) {
      let { query, reset } = e;
      this.currentArea = query.parentAreaIds;
      this.updateQuery(query, reset);
    },
    // 当前选中的学期
    getCurrentTerm(term) {
      this.currentTerm = term.id || "";
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isOption: true,
        // isKnowlegdeCatalog: true,
        isClass: true,
        isScene: true,
        isYear: true,
        isArea: true,
        isRange: true,
        isGrade: true,
        isTerm: true,
        isOrder: true,
        isFileType: true,
        isSubType: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      // 更新路由的query
      this.updateQuery(query, isResetRouteQuery);
    },
    // 选中文档类型排序
    selectDocumentType(item) {
      this.currentFileType = item.id;
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        isRange: true,
        isOption: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isClass: true,
        isKeywords: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    // 选中文档类型排序
    selectExamScope(item) {
      this.currentRange = item.id;
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        isRange: true,
        isOption: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isClass: true,
        isKeywords: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    getCurrentTeachResearch(item) {
      this.currentTeachResearch = item.id;
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isOption: true,
        isClass: true,
        isKeywords: true,
        isUpdateStatus: true,
        isScene: true,
        isRange: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        // isSubjectCharacteristic: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    getCurrentSubjectCharacteristic(item) {
      this.currentExperimentForm = item.id;
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isOption: true,
        isClass: true,
        isKeywords: true,
        isUpdateStatus: true,
        isScene: true,
        isRange: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        isExperimentForm: true,
        isTeachResearch: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      // console.log("query", query);
      this.updateQuery(query, isResetRouteQuery);
    },
    getCurrentTeachResearch(item) {
      this.currentTeachResearch = item.id;
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isOption: true,
        isClass: true,
        isKeywords: true,
        isUpdateStatus: true,
        isScene: true,
        isRange: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        // isSubjectCharacteristic: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    getCurrentSubjectCharacteristic(item) {
      this.currentExperimentForm = item.id;
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isOption: true,
        isClass: true,
        isKeywords: true,
        isUpdateStatus: true,
        isScene: true,
        isRange: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        isExperimentForm: true,
        isTeachResearch: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);

      // console.log("query", query);
      this.updateQuery(query, isResetRouteQuery);
    },
    getCurrentTextBookVersion(item) {
      this.currentTextBookVersion = item.id;
      let query = this.constructQuery({
        // [this.catalogType]: true,
        isCategory: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isOption: true,
        isClass: true,
        isKeywords: true,
        isUpdateStatus: true,
        isScene: true,
        isRange: true,
        isSubType: true,
        isFileType: true,
        isTerm: true,
        isGrade: true,
        isExperimentForm: true,
        isTeachResearch: true,
        isVersion: true,
        isSeries: true,
      });
      this.updateQuery(query, isResetRouteQuery);
    },

    // 切换资料的类型
    changeSoftType(id) {
      // console.log("id", id);
      if (id == 2 && this.isDisableCheckAlbum) {
        return;
      }
      let query = JSON.parse(JSON.stringify(this.$route.query));
      let path = this.$route.path;
      // console.log("this.currentFilterList", this.currentFilterList);
      let excludeFilterParams =
        id == 1 || path.includes("juemi")
          ? []
          : this.currentFilterList.excludeFilterParams;
      if (this.currentSoftType != id) {
        this.currentSoftType = id;
        this.currentKPointTreeNode = null;
        // id == 2
        //   ? (query.orders = "update_time" + this.orderSort)
        //   : delete query.orders;
        if (id == 2) {
          query.orders = "update_time" + this.orderSort;
          delete query.paperAnswer;
          delete query.paperExp;
          delete query.paperMedia;
        } else {
          delete query.orders;
        }
        query.softType = id;
        this.currentOrder = id == 2 ? "update_time" : "";
        query.pageIndex = 1;
        // console.log("排除的参数", excludeFilterParams);
        // 过滤不同的参数
        for (let key in query) {
          if (excludeFilterParams.includes(key)) {
            delete query[key];
          }
        }
        this.updateQuery(query, true);
      }
    },
    // 选中更新状态
    selectUpdateStatus(item) {
      this.currentUpdateStatus = item.code;
      let path = this.$route.path;

      let params = {
        isCategory: true,
        isOrder: true,
        isArea: true,
        isYear: true,
        isClass: true,
        isKeywords: true,
        isUpdateStatus: true,
        isScene: true,
        isTerm: true,
        isGrade: true,
        isRange: true,
        isSubType: true,
        isSchool: true,
      };
      if (path.includes("juemi")) {
        params.isSeries = true;
      } else {
        params[this.catalogType] = true;
      }
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      // console.log("query", query);
      this.updateQuery(query, isResetRouteQuery);
    },
    // 文档排序 最新/ 浏览量
    documentOrder(order, name) {
      // 排序
      this.currentOrder = order;
      let path = this.$route.path;
      let params = {
        isCategory: true,
        isScene: true,
        isRange: true,
        isOption: true,
        isArea: true,
        isTerm: true,
        isGrade: true,
        isYear: true,
        isClass: true,
        isKeywords: true,
        isArea: true,
        isYear: true,
        isClass: true,
        isOrder: true,
        isUpdateStatus: true,
        isTeachResearch: true,
        isSubType: true,
        isFileType: true,
        isExperimentForm: true,
        isSchool: true,
        isVersion: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      if (path.includes("juemi")) {
        params.isSeries = true;
      } else {
        params[this.catalogType] = true;
      }
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    // 试题试卷的特殊选项
    getCurrentOption(item, parent) {
      let { isMulti } = parent;
      let currentOption = this.currentOption[item.paramName];
      // 点击选中先判断是多选还是单选
      if (isMulti) {
        if (!currentOption) {
          this.currentOption[item.paramName] = item.paramVal;
        } else {
          let currentOptionArr = currentOption.split(",");
          let currentOptionItem = currentOptionArr.find(
            (option) => option == item.paramVal
          );
          if (currentOptionItem) {
            currentOptionArr = currentOptionArr.filter(
              (option) => option != item.paramVal
            );
          } else {
            currentOptionArr.push(item.paramVal);
          }
          this.currentOption[item.paramName] = currentOptionArr.join(",");
        }
      } else {
        if (!currentOption || item.paramVal !== currentOption) {
          this.currentOption[item.paramName] = item.paramVal;
        } else {
          this.currentOption[item.paramName] = "";
        }
      }
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        // isRange: true,
        isOption: true,
        // isArea: true,
        // isClass: true,
        // isYear: true,
        isArea: true,
        isYear: true,
        isGrade: true,
        isTerm: true,
        isClass: true,
        isRange: true,
        isSubType: true,
        isFileType: true,
        isTeachResearch: true,
        isExperimentForm: true,
        isSchool: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      this.updateQuery(query, isResetRouteQuery);
    },
    handleInitFilterList(filterList, excludeFilterOptions = []) {
      // console.log("filterList----", filterList, excludeFilterOptions);
      let excludeFilterParams = [];
      for (let key in filterList) {
        let currentFilter = filterList[key];
        // let excludeFilterOptions =
        // filterList && filterList.excludeFilterOptions
        //   ? filterList.excludeFilterOptions
        //   : [];

        // let
        // console.log(currentFilter)
        if (typeof currentFilter == "object" && currentFilter) {
          switch (key) {
            case "resourceTypeTagList":
              currentFilter.key = 1;
              currentFilter.paramKey = "parentTypeId";
              break;
            case "commercialLevelTagList":
              currentFilter.key = 2;
              currentFilter.paramKey = "commercialLevel";
              break;
            case "areaList":
              currentFilter.key = 3;
              currentFilter.paramKey = "parentAreaIds";
              break;
            case "yearList":
              currentFilter.key = 4;
              currentFilter.paramKey = "year";
              break;
            case "gradeList":
              currentFilter.key = 5;
              currentFilter.paramKey = "gradeIds";
              break;
            case "termList":
              currentFilter.key = 6;
              currentFilter.paramKey = "term";
              break;
            case "fileTypeTagList":
              currentFilter.key = 7;
              currentFilter.paramKey = "fileTypeId";
              break;
            case "teachingResearchTagList":
              currentFilter.key = 8;
              currentFilter.paramKey = "teachResearch";
              break;
            case "expireFormList":
              currentFilter.key = 9;
              currentFilter.paramKey = "subjectFeatureType";
              break;
            case "examScopeList":
              currentFilter.key = 10;
              currentFilter.paramKey = "examScope";
              break;
          }
          // console.log("excludeFilterOptions", excludeFilterOptions);
          if (excludeFilterOptions.includes(currentFilter.key)) {
            // console.log('currentFilter',currentFilter)
            excludeFilterParams.push(currentFilter.paramKey);
          }
        }
      }
      // console.log("excludeFilterParams", excludeFilterParams);
      filterList.excludeFilterParams = excludeFilterParams;
      return filterList;
    },
    handleCatalogsStatus(data = [], key = "isExamCatalog") {
      if (!data || !data.length) {
        return;
      }
      data.forEach((item) => {
        // if (item.typeCode == 6 || item.typeCode == 7) {
        //   item.childCatalogList = item.childList ? item.childList : [];
        // }
        if (item.typeCode == 6 || item.typeCode == 7) {
          let keyName =
            item.typeCode == 6
              ? "isSubjectCharacteristic"
              : "isParentSubjectFeatures";
          item[keyName] = true;
        } else if (item.typeCode == 3) {
          item["isCatalog"] = true;
        } else {
          item[key] = true;
        }
        if (item.childList && item.childList.length) {
          this.handleCatalogsStatus(item.childList, key);
        }
      });
    },
    handleTreeShowStatus(list, id, currentTreeName = "currentTreeNode") {
      list.some((catalog) => {
        if (catalog.id == id) {
          this.$set(catalog, "isShow", true);
          this[currentTreeName] = catalog.id;
          return true;
        } else {
          if (catalog.childList && catalog.childList.length > 0) {
            // console.log("catalog-----", catalog);
            let findStatus = this.initShowStatus(
              catalog.childList,
              id,
              currentTreeName
            );
            // console.log("findStatus2", catalog, findStatus);
            this.$set(catalog, "isShow", findStatus);
            return findStatus;
          }
        }
      });
    },
    initShowStatus(data = [], id, currentNodeName) {
      // console.log("data, id, currentNodeNam", data, id, currentNodeName);
      let findStatus = false;
      data.some((item) => {
        if (item.id == id) {
          findStatus = true;
          this.$set(item, "isShow", true);
          currentNodeName ? (this[currentNodeName] = item.id) : null;
          return true;
        } else {
          // return this.initShowStatus(
          let findItemStatus = this.initShowStatus(
            item.childList || [],
            id,
            currentNodeName
          );
          this.$set(item, "isShow", findItemStatus);
          findStatus = findItemStatus;
          return findItemStatus;
        }
      });
      return findStatus;
    },
    changeCurrentGrade(item, index) {
      this.gradeIndex = index;
      this.termIndex = null;
      // this.getAreaList();
    },
    async changeCurrentTerm(item, index) {
      this.termIndex = index;
      // 修改路由
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.gradeId = this.gradeList[this.gradeIndex].id;
      query.termId = item.id;
      console.log("query", query);

      // 判断是否需要更新年级学期
      const findGradeIndex = this.gradeList.findIndex((item) => item.isUsed);
      const findTermIndex = this.termList.findIndex((item) => item.isUsed);
      if (this.gradeIndex !== findGradeIndex || index !== findTermIndex) {
        // 更新绝密年级和学期
        let result = await updateLastUsedGradeAndTerm({
          gradeId: this.gradeList[this.gradeIndex].id,
          productId: 8,
          stageId: this.currentCourse.stageId,
          subjectId: this.currentCourse.subjectId,
          term: item.id,
        });

        // 如果更新成功,修改路由参数
        if (result.result) {
          let query = JSON.parse(JSON.stringify(this.$route.query));
          query.gradeId = this.gradeList[this.gradeIndex].id;
          query.termId = item.id;
          this.showName = `${this.gradeList[this.gradeIndex].name} ${
            this.termList[this.termIndex].name
          }`;
          // this.getPageFilters();
          this.getGradeAndTermList();
          this.updateQuery(query, true);
        }
      }

      // 避免递归调用自身方法导致堆栈溢出
      // this.updateQuery(query, true);
    },
    async changeCurrentVersion(item) {
      // console.log("item--", item);
      let textbooksList = null;
      if (item.id) {
        this.currentVersionId = item.id;
        this.currentVersion = item;
        let { result: textbooks } = await getTextbooks({
          versionId: item.id,
        });
        textbooksList = textbooks;
      } else {
        this.isFoldVersion = false;
        this.catalogs = [];
        this.currentTextbook = textbooksList[0];
        this.changeTextbook(textbooksList[0]);
        // this.bookDialogVisible = false;
      }
      this.currentTextBookId = 0;
      this.changeTextBookList(textbooksList);
      // this.textBookList = textbooksList;
    },
    // 重置参数
    handleReset() {
      // console.log("点击重置");
      // 重置排除的参数
      let isJuemi = this.$route.path.indexOf("/juemi") > -1;
      let query = JSON.parse(JSON.stringify(this.$route.query));
      // console.log("排除的参数", query);
      let pageId = query.pageId || 1;
      let excludeParams = [
        "stageId",
        "subjectId",
        "courseId",
        "pageIndex",
        "pageSize",
        "softType",
        "pageId",
      ];
      let params = [];
      let deleteParams = [];
      if (pageId == 1) {
        params = ["parentCatalogIds", "textbookId"];
      } else if (pageId == 3) {
        params = ["parentKPointId"];
      } else if (pageId == 2) {
        params = ["parentScenarioId", "parentScenarioKpoints"];
      } else if (pageId == 5) {
        params = ["subjectFeatureType", "parentSubjectFeatures"];
      } else if (pageId == 9) {
        params = ["seriesId"];
      } else if (pageId == 10) {
        params = ["parentAreaIds", "schoolId"];
      } else {
        this.currentKPointTreeNode = null;
        params = ["parentScenarioId"];
      }
      if (isJuemi) {
        params = params.concat(["termId", "gradeId"]);
      }
      excludeParams = excludeParams.concat(params);
      // console.log("排除的参数", excludeParams, query);
      for (let key in query) {
        if (excludeParams.indexOf(key) === -1) {
          // console.log("需要删除的参数", key);
          deleteParams.push(key);
          delete query[key];
        }
      }
      // 如果有删除的按钮才重置
      if (deleteParams.length > 0) {
        // console.log("删除后的参数", query);
        this.$router.replace({ query });
      }
    },
    // 搜索功能
    search(e) {
      // console.log("catalogType", this.catalogType);
      let params = {
        [this.catalogType]: true,
        isCategory: true,
        isScene: true,
        isRange: true,
        isOption: true,
        isFilteDropdown: true,
        isFileType: true,
        isOrder: true,
        isArea: true,
        isGrade: true,
        isTerm: true,
        isTree: true,
        isYearRange: true,
        isUpdateStatus: true,
        isExperimentForm: true,
        isSchool: true,
        // isScsyCatalog: true,
      };
      this.$route.path.indexOf("mingxiao") > -1
        ? delete params[this.catalogType]
        : null;
      let query = this.constructQuery(params);
      if (e) {
        query.title = e;
      }
      // console.log("query----", query);
      // 更新路由的query,
      this.updateQuery(query, isResetRouteQuery);
    },
    // 处理目录
    handleCatalogList() {
      let catalogList = [];
      // console.log("versionList----", this.versionsList);
      let versionList = this.versionList.filter((item) => item.name != "不限");
      versionList.forEach((version) => {
        version.title = version.name;
        // 是否是版本
        version.isVersion = true;
      });
      catalogList.push({
        title: "教材",
        id: "0",
        parentId: "0",
        childCatalogList: versionList,
      });
      // console.log("catalogList", catalogList);
      this.catalogs = catalogList;
      this.$set(this.catalogs[0], "isShow", true);

      this.teachLists = JSON.parse(JSON.stringify(catalogList));
    },
    async judgeShowToSyncPageBtn() {
      let {
        parentCatalogIds,
        parentScenarioId,
        courseId,
        stageId,
        subjectId,
        textbookId,
        experimentForm,
        tabId,
      } = this.$route.query;
      if (
        (!parentCatalogIds && !parentScenarioId) ||
        !stageId ||
        !courseId ||
        !stageId ||
        !subjectId ||
        !textbookId
      ) {
        this.syncUrl = "";
        return;
      }
      let data = await getSyncUrl({
        catalogId: parentCatalogIds,
        courseId: Number(courseId),
        scenarioId: parentScenarioId,
        stageId: Number(stageId),
        subjectId: Number(subjectId),
        textBookId: Number(textbookId),
        versionId: this.currentTextbook.versionId,
        columnId: Number(tabId),
      });
      this.syncUrl = data.result || "";
    },
    handleOpenPreview({ index, softId }) {
      this.showPreviewDialog = true;
      this.currentIndex = index;
      this.currentPreviewSoftId = softId;
    },
  },
};
